import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

// Canvas-based text measurement utility
let measureCanvas;
function getTextWidth(text, fontFamily = "Arial", fontSize = 12) {
  if (!measureCanvas) {
    measureCanvas = document.createElement("canvas");
  }
  const context = measureCanvas.getContext("2d");
  context.font = `${fontSize}px ${fontFamily}`;
  const metrics = context.measureText(text);
  return metrics.width;
}

// Constants
const TOOLTIP_BG_HEIGHT = 18;
const TOOLTIP_BG_PADDING = 6;

class CoppockTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill, bgFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const coppock = isDefined(currentItem) && yAccessor(currentItem);
    const value = (coppock && displayFormat(coppock)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Hide tooltip if value is n/a
    if (shouldHideField(value)) {
      return null;
    }

    // Build label with all three parameters
    const period = options.period || 10;
    const shortRoC = options.shortRoC || 11;
    const longRoC = options.longRoC || 14;
    const tooltipLabel = `Coppock (${period},${shortRoC},${longRoC}): `;
    const fullText = tooltipLabel + value;

    // Calculate text width for background
    const textWidth = getTextWidth(
      fullText,
      fontFamily || "Arial",
      fontSize || 12,
    );
    const bgWidth = textWidth + TOOLTIP_BG_PADDING * 2;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-coppock"
      >
        {/* Background rectangle */}
        <rect
          x={-TOOLTIP_BG_PADDING}
          y={-5}
          width={bgWidth}
          height={TOOLTIP_BG_HEIGHT}
          fill={bgFill || "#1f2937"}
          rx={6}
          ry={6}
        />
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{value}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

CoppockTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
    shortRoC: PropTypes.number.isRequired,
    longRoC: PropTypes.number.isRequired,
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  yAccessor: PropTypes.func,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  bgFill: PropTypes.string,
};

CoppockTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip-hover",
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  yAccessor: (d) => d.coppock,
  labelFill: "#4682B4",
  textFill: "#FFFFFF",
};

export default CoppockTooltip;
